import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

const Section6Text78c = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    houseAreaAccordingTasritHahira,
  } = context.data.pdfData;

    return (
    <div ref={ref}>
      {Boolean(houseAreaAccordingTasritHahira) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={styles.bold}>שטח בהתאם לתשריט חכירה: </span>
          <span>{getBreakLinesTextShumaType3(houseAreaAccordingTasritHahira)}</span>
        </div>
      )}
    </div>
  )
});

export default Section6Text78c;
